import React, { useState } from "react";
import { Button, Form, Input, Select, Toast } from "../../../../Components";
import { FaArrowRight } from "react-icons/fa";
import { PHONE_CODE_OPTIONS } from "../../../../Utils/constants";
import { validateEmail, validatePhoneNumberDetailed } from "../../../../Utils/utils";

function AddOffice({ onSubmit = () => {}, onBack = () => {}, details = {} }) {
	const [Values, setValues] = useState({
		gstin: "",
		address: "",
		name: "",
		email: "",
		phone: "",
		phoneCode: {},
		head: {},
	});

	const handleSubmit = async () => {
		if (!Values.gstin || !Values.name || !Values.email || !Values.phone) {
			return Toast.error("Please provide all the details");
		}
		if (!validateEmail(Values.email)) {
			return Toast.error("Please enter a valid email");
		}
		const phoneResult = await validatePhoneNumberDetailed(Values.phone, Values.phoneCode?.value);
		if (!phoneResult.ok) {
			return Toast.error(phoneResult.message);
		}
		const { phoneCode, ...payload } = Values;
		onSubmit({
			...payload,
			head: Values.head.value,
		});
	};

	return (
		<div className="p-10 text-center fade-in-right">
			<h1 className="text-4xl font-bold">Add Office</h1>
			<div className="mt-2 text-xl font-thin">We will create a single office for you. If you want you can add more later</div>
			<Form onSubmit={handleSubmit} className="mt-8 flex flex-col gap-4 max-w-[400px] m-auto">
				<Input value={Values.gstin} onChange={(gstin) => setValues((prev) => ({ ...prev, gstin: gstin.toUpperCase() }))} required placeholder="Office GSTIN" />
				<Input value={Values.name} onChange={(name) => setValues((prev) => ({ ...prev, name }))} required placeholder="Office Name" />
				<Input value={Values.address} onChange={(address) => setValues((prev) => ({ ...prev, address }))} required placeholder="Office Address" />
				<Input type="email" value={Values.email} onChange={(email) => setValues((prev) => ({ ...prev, email: email.toLowerCase() }))} required placeholder="Office Email" />
				<div>
					<label>Office Phone</label>
					<div className="flex gap-2 mt-2">
						<Select className="max-w-min" placeholder="Code" selected={Values.phoneCode} onChange={(phoneCode) => setValues((prev) => ({ ...prev, phoneCode }))} options={PHONE_CODE_OPTIONS} />
						<Input className="flex-1" type="number" value={Values.phone} onChange={(phone) => setValues((prev) => ({ ...prev, phone }))} required placeholder="Phone" />
					</div>
				</div>
				{details.users?.length > 0 && (
					<Select
						placeholder="Select Office Head for Approvals"
						btnClass="w-full"
						options={details.users.map((user) => ({
							label: user,
							value: user,
						}))}
						onChange={(user) => setValues((prev) => ({ ...prev, head: user }))}
						selected={Values.head}
					/>
				)}
				<div className="flex m-auto mt-4 gap-x-2 max-w-min">
					<Button onClick={onBack} className="flex-grow">
						Back
					</Button>
					<Button type="submit" variant="primary" className="flex-grow">
						Continue <FaArrowRight className="ml-2" />
					</Button>
				</div>
			</Form>
		</div>
	);
}

export default AddOffice;
